import styled from "styled-components";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";

export const CommercialLaw: React.FC = () => {
  return (
    <Container>
      <TitleWrapper>特定商取引法に基づく表記</TitleWrapper>

      <ArticleHeader> 会社概要</ArticleHeader>
      <ArticleTableContent>
        <table>
          <tbody>
            <tr>
              <td className="label">会社名</td>
              <td className="info">株式会社ジョイフル</td>
            </tr>
            <tr>
              <td className="label">所在地</td>
              <td className="info">
                <p>大分本社</p>
                <p>〒870-0141 大分県大分市三川新町一丁目1番45号</p>
              </td>
            </tr>
            <tr>
              <td className="label">電話番号</td>
              <td className="info">
                <p>大分本社</p>
                <p>TEL 097-551-7131（代）</p>
              </td>
            </tr>
            <tr>
              <td className="label">代表者</td>
              <td className="info">代表取締役社長 穴見 くるみ</td>
            </tr>
          </tbody>
        </table>
      </ArticleTableContent>
      <Article>
        <ArticleHeader>商品の価格について</ArticleHeader>
        <ArticleContent>
          <Text>各商品ごとに表示しています（表示価格）。</Text>
          <Text>消費税はすべて商品代金(税込価格)に含んで表示しています。</Text>
        </ArticleContent>
      </Article>
      <Article>
        <ArticleHeader>販売数量の制限について</ArticleHeader>
        <ArticleContent>
          ご指定の店舗またはご指定の日時により、販売数量に制限がある場合があります。
        </ArticleContent>
      </Article>
      <Article>
        <ArticleHeader>商品の提供について</ArticleHeader>
        <ArticleContent>
          <Text>
            お客様のご指定の商品受取り店舗・日時にてお受取り下さい（営業時間内に限ります）。
          </Text>
          <Text>
            指定日時を過ぎても店舗に来店されない場合は、注文をキャンセルしたものとさせていただく場合があります。
          </Text>
        </ArticleContent>
      </Article>
      <Article>
        <ArticleHeader>返品について</ArticleHeader>
        <ArticleContent>
          <Text>
            商品の特性上、お客様都合による返品は原則としてお断りさせていただいております。
          </Text>
          <Text>
            品質には万全を期しておりますが、万が一商品に不備があった場合は、商品お受取り日当日（賞味期限内に限る）にお受取り店舗にご連絡ください。
          </Text>
        </ArticleContent>
      </Article>
      <Article>
        <ArticleHeader>代金支払方法について</ArticleHeader>
        <ArticleContent>
          <Text>ご指定のお受取り店舗にて下記の方法でお支払いください。</Text>
          <Text>
            現金引換、クレジット決済、電子マネー決済（クレジット決済、電子マネー決済は一部店舗ではご利用できません。）
          </Text>
        </ArticleContent>
      </Article>
      <Article>
        <ArticleHeader>推奨閲覧環境について</ArticleHeader>
        <ArticleTableContent>
          <table>
            <tbody>
              <tr>
                <td className="label">OS環境</td>
                <td className="info">
                  PC：Windows10、Mac OS X以降
                  <br />
                  スマートフォン：Android8.0以降、iOS14以降
                </td>
              </tr>
              <tr>
                <td className="label">推奨ブラウザ</td>
                <td className="info">
                  PC：Google Chrome（最新版）、Firefox（最新版）、Safari
                  （最新版）、Edge（最新版）
                </td>
              </tr>
              <tr>
                <td className="label">Javascriptについて</td>
                <td className="info">
                  当Webサイト「Joyfull
                  ネット注文」では、JavaScriptを使用しております。ご使用のブラウザ設定でJavaScriptを無効にされている場合、正しく機能しない、または正しく表示されないことがございます。ご利用の際にはブラウザ設定でJavaScriptを有効にしていただきますようお願いいたします。
                </td>
              </tr>
              <tr>
                <td className="label">クッキーについて</td>
                <td className="info">
                  当Webサイト「Joyfull
                  ネット注文」では、クッキーを使用しております。正しくご利用いただくため、お使いのブラウザのメニュー設定で、クッキーを受け取れる設定か、ご確認いただけますようお願いいたします。
                </td>
              </tr>
            </tbody>
          </table>
        </ArticleTableContent>
      </Article>
      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 16px 61px;
  color: #333333;
`;

const TitleWrapper = styled.p`
  font-size: 20px;
  padding: 43px 0 28px 0;
  display: flex;
  line-height: 1;
  font-weight: 500;
  justify-content: center;
  font-family: "Hiragino Sans";
`;

const Article = styled.div`
  margin-top: 32px;
`;

const ArticleHeader = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 26px;
  border-bottom: 1px solid #000;
  margin: 8px 0 10px 0;
  font-family: "Hiragino Sans";
`;

const ArticleTableContent = styled.div`
  table {
    line-height: 24px;
    font-size: 14px;
    font-weight: 200;

    tr {
      td {
        border-bottom: 3px solid transparent;
        font-family: "Hiragino Sans";
      }
    }

    .label {
      width: 20.5%;
      vertical-align: top;
      font-family: "Hiragino Sans";
    }

    .info {
      width: 79.5%;
      padding-left: 13px;

      p {
        font-family: "Hiragino Sans";
      }
    }
  }
`;

const ArticleContent = styled.div`
  line-height: 20px;
  font-size: 14px;
  font-weight: 200;
  font-family: "Hiragino Sans";
`;

const Text = styled.p`
  font-family: "Hiragino Sans";
  line-height: 20px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 60px;
  button {
    height: auto;
    line-height: 1;
    font-weight: 600;
  }
`;
